export const viewTransition = () => {
  // ページ遷移を処理する関数
  function handleNavigation(event) {
    // クリックされた要素がリンク自体でない場合（例：リンク内の画像やテキストなど）、
    // 最も近い親のaタグを取得
    const link = event.target.closest('a');
    
    // リンクが存在しない、または外部リンクの場合は通常の遷移を行う
    if (!link || link.target === '_blank' || link.hostname !== window.location.hostname) {
      return;
    }

    // リンクのクリックをキャンセル
    event.preventDefault();
    
    // View Transitions APIがサポートされているか確認
    if (!document.startViewTransition) {
      window.location.href = link.href;
      return;
    }

    // View Transitionを開始
    document.startViewTransition(() => {
      window.location.href = link.href;
    });
  }

  // すべての内部リンクに適用
  document.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', handleNavigation);
  });
}